/**
 * 项目送审实体
 */

import { useState, useEffect } from 'react';
import {
    ConfigProvider,
    Modal,
    Row,
    Col,
    message,
    InputNumber,
    DatePicker,
    Input,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    rff,
    currentDate,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import locale from 'antd/es/date-picker/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';

const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [auditDate, setAuditDate] = useState(currentDate);
    const [auditAmount, setAuditAmount] = useState(0);
    const [auditUnit, setAuditUnit] = useState('');
    const [description, setDescription] = useState('');

    const cancel = () => {
        setOpen(false);
        setLoading(false);
        setAuditDate(currentDate);
        setAuditAmount(0);
        setAuditUnit('');
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setAuditDate(props.record.audit_date ? props.record.audit_date : currentDate);
            setAuditAmount(props.record.audit_amount > 0 ? props.record.audit_amount : props.record.contract_amount);
            setAuditUnit(props.record.audit_unit);
        }
    }, [props.record]);

    useEffect(() => {
        setOpen(props.open);
    }, [props]);

    const ok = () => {
        if (auditAmount <= 0) {
            messageApi.error('送审金额不能为零！');
            return;
        }
        if (auditUnit === '') {
            messageApi.error('审计单位不能为空！');
            return;
        }
        if (auditDate === '') {
            messageApi.error('送审时间不能为空！');
            return;
        }
        // 参数校验
        setLoading(true);
        // 执行操作
        $.ajax({
            url: `${CNF.api}project/details/${props.record.key}`,
            headers: AddRequestHeaders(),
            type: 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                'action': CNF.actionName.TOAUDIT,
                'audit_date': auditDate,
                'audit_amount': auditAmount,
                'audit_unit': auditUnit,
                'description': description,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            setLoading(false);
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };

    return (
        <ConfigProvider
            locale={locale}
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR,
                },
            }}
        >
            {contextHolder}
            <Modal
                width={500}
                title={props.record ? props.record.name : ''}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={24}>{rff}送审金额</Col>
                    <Col span={24}>
                        <InputNumber
                            style={{ width: '100%' }}
                            formatter={value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            min={0}
                            step='0.01'
                            value={auditAmount}
                            onChange={(value) => setAuditAmount(value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>{rff}审计单位</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            value={auditUnit}
                            onChange={(e) => setAuditUnit(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>{rff}送审时间</Col>
                    <Col span={24}>
                        <DatePicker
                            placeholder='请选择日期'
                            style={{ width: '100%' }}
                            locale={locale}
                            value={dayjs(auditDate, 'YYYY-MM-DD')}
                            onChange={(_, dateString) => setAuditDate(dateString)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>备注</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='备注可写在这里...'
                            rows={2}
                            autoSize={{ minRows: 2, maxRows: 3 }}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
            </Modal>
        </ConfigProvider>
    );
}

export default Entity